module.exports = __webpack_public_path__ + "static/media/add-call.4eb163d1.svg";